"use strict";
/**
 * @author Aram.Nurijanyan on 19/03/2018
 */
Object.defineProperty(exports, "__esModule", { value: true });
var FrameworkLevel = /** @class */ (function () {
    function FrameworkLevel(nameTemplateId, level, iFLevelId, sequenceId, separatorId, prefix, suffix, settings) {
        this.nameTemplateId = nameTemplateId;
        this.level = level;
        this.iFLevelId = iFLevelId;
        this.sequenceId = sequenceId;
        this.separatorId = separatorId;
        this.prefix = prefix;
        this.suffix = suffix;
        this.settings = settings || null;
    }
    return FrameworkLevel;
}());
exports.FrameworkLevel = FrameworkLevel;
//# sourceMappingURL=framework-level.model.js.map